module.exports = __webpack_public_path__ + "img/logo-light.e7aab0cd.png";